import React, { useEffect, useState } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import moment from 'moment';
import { connect } from 'react-redux';
import * as selectors from '../../store/selectors';
import {
  clearStatisticsFilters,
  getStatistics,
} from '../../store/statistics.actions';
import FullScreenDialog from '../FullScreenDialog';
import * as dateHelper from '../../helpers/dates';
import { useEventCallback } from '../../helpers/hooks';
import { DatePicker } from '@mui/x-date-pickers';
import Button from '@mui/material/Button';
import GetAppIcon from '@mui/icons-material/GetApp';
import Typography from '@mui/material/Typography';
import { createTjmReport } from '../../reports/tjm-report';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
  reportContainer: {
    display: 'flex',
    alignItems: 'baseline',
    '& > *:not(:last-child)': {
      marginRight: theme.spacing(2),
    },
  },
  flightsCount: {
    flex: '0 0 auto',
  },
  downloadButton: {
    flex: '0 0 auto',
  },
}));

const ReportsDialog = ({
  events,
  getStatistics,
  clearStatisticsFilters,
  isOpen,
  onClose,
}) => {
  const [date, setDate] = useState(moment());
  const classes = useStyles();
  const { t } = useTranslation();
  const handleFiltersClear = useEventCallback(
    () => clearStatisticsFilters(),
    []
  );

  useEffect(() => {
    handleFiltersClear();
  }, [handleFiltersClear]);

  useEffect(() => {
    const range = dateHelper.dateToMonthRange(date);
    getStatistics(range);
  }, [getStatistics, date]);

  const handleReportDownload = useEventCallback(() => {
    createTjmReport(events);
  });

  const handleYearMonthChange = useEventCallback(date => {
    setDate(date);
  });

  return (
    <FullScreenDialog isOpen={isOpen} title="Reports" onClose={onClose}>
      <div className={classes.reportContainer}>
        <DatePicker
          openTo="month"
          views={['year', 'month']}
          label={t('Year_and_Month')}
          value={date}
          slotProps={{ field: { variant: 'standard' } }}
          onChange={handleYearMonthChange}
        />
        <Typography
          className={classes.flightsCount}
          noWrap
        >{`${events.length} flights`}</Typography>
        <Button
          className={classes.downloadButton}
          size="small"
          variant="contained"
          startIcon={<GetAppIcon />}
          onClick={handleReportDownload}
        >
          {t('Download')}
        </Button>
      </div>
    </FullScreenDialog>
  );
};

const mapDispatchToProps = {
  getStatistics,
  clearStatisticsFilters,
};

export default connect(
  state => ({
    events: selectors.getSortedStatistics(state),
    rampServices: selectors.getSortedRampServices(state),
  }),
  mapDispatchToProps
)(ReportsDialog);
